__turbopack_context__.v({
  "dot": "HotspotDot-module-scss-module__hXb6zq__dot",
  "dotInner": "HotspotDot-module-scss-module__hXb6zq__dotInner",
});
